module.exports = "<footer class=\"main-footer\">\r\n \r\n  <span class=\"m-auto\"></span>\r\n  Design & Developed by <a href=\"#\"> Vishleshan</a>\r\n</footer>"